import React, { lazy, Suspense } from 'react';

import { AnalyticsErrorBoundary } from '@atlaskit/analytics-next';

import { failUfoExperience, UfoExperiences } from '../../ufo-experiences';
import type { ShareToSlackProps } from '../common/types';

import Loading from './Loading';

export default function LazyBulkShareToSlack(props: ShareToSlackProps): React.JSX.Element {
	const LazyShareToSlack = lazy(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_share-to-slack-clone" */
				'./ShareToSlack'
			),
	);

	return (
		<AnalyticsErrorBoundary
			onError={() => {
				failUfoExperience(UfoExperiences.SLACK_SEGMENT_RENDERED);
				failUfoExperience(UfoExperiences.SLACK_FORM_ENABLED);
			}}
			channel={'shareToSlack'}
			data={{}}
		>
			<Suspense fallback={<Loading />}>
				<LazyShareToSlack {...props} />
			</Suspense>
		</AnalyticsErrorBoundary>
	);
}
